import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { NavLink as BaseNavLink } from 'react-router-dom';
const NavLink = /*#__PURE__*/ forwardRef(({ activeClassName, activeStyle, ...props }, ref)=>{
    return /*#__PURE__*/ React.createElement(BaseNavLink, {
        ref: ref,
        ...props,
        className: ({ isActive })=>[
                props.className,
                isActive ? activeClassName : null
            ].filter(Boolean).join(' '),
        style: ({ isActive })=>({
                ...props.style,
                ...isActive ? activeStyle : null
            })
    });
});
NavLink.displayName = 'Navlink';
NavLink.propTypes = {
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.string
};
export default NavLink;
